/**
 * 治理相关store
 */
import {
  getGovernanceCommonEnum,
} from "@/api/govern-system/common";
const state = {
  // 治理
  governanceEnum: null
}
const mutations = {
  SET_GOVERNANCE: (state, governanceEnum) => {
    state.governanceEnum = governanceEnum
  }
}
const actions = {
  // 获取治理枚举
  getGovernanceEnum({ commit, state }, payload) {
    return new Promise(async (resolve, reject) => {
      if (state.governanceEnum) {
        resolve(state.governanceEnum)
      } else {
        try {
          const { data } = await getGovernanceCommonEnum(payload)
          commit('SET_GOVERNANCE', data)
          resolve(data)
        } catch (error) {
          reject(error)
        }
      }
    })
  }
}
export default {
  namespaced: true,
  actions,
  state,
  mutations
}
